export function parseQuery(
  queryString: string = ''
): { [key: string]: string } {
  let match
  const pl = /\+/g
  const search = /([^&=]+)=?([^&]*)/g
  const decode = (s: string) => decodeURIComponent(s.replace(pl, ' '))

  queryString = queryString.replace(/^\?/g, '')
  const urlParams: { [key: string]: string } = {}
  while ((match = search.exec(queryString))) {
    if (match[1]) {
      urlParams[decode(match[1])] = !match[2] ? '' : decode(match[2])
    }
  }
  return urlParams
}

export function currentURL(): URL {
  return new URL(window.document.location.href)
}

